import React from 'react';
import { Link, useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { toggleLights, toggleSpace, toggleDarkMode } from '../features/theme/themeActions';
import './Header.css';

function Header() {
  const darkMode = useSelector((state) => state.darkMode);
  const lightsOn = useSelector((state) => state.lightsOn);
  const spaceOn = useSelector((state) => state.spaceOn);
  const dispatch = useDispatch();

  const location = useLocation();

  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  const handleToggleMenu = (e) => {
    // only toggle menu state in mobile view
    if (window.innerWidth > 768) return;
    setMenuIsOpen(!menuIsOpen);
  };

  const handleToggleLights = () => dispatch(toggleLights());
  const handleToggleSpace = () => dispatch(toggleSpace());
  const handleToggleDarkMode = () => dispatch(toggleDarkMode());


  return (
    <header className='Header'>
      <div className='Header__logo-container'>
        <Link to='/' className='Header__logo-link'>
          Hello
        </Link>
      </div>

      <div className='Header__nav-container'>
        <div className='Header__theme-buttons-container'>
          <button
            onClick={handleToggleDarkMode}
            className='Header__nav-button Header__nav-button--dark-mode'
          >
            {darkMode ? (
              <svg
                stroke='currentColor'
                fill='currentColor'
                strokeWidth='0'
                viewBox='0 0 16 16'
                height='1em'
                width='1em'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z'></path>
              </svg>
            ) : (
              <svg
                stroke='currentColor'
                fill='currentColor'
                strokeWidth='0'
                viewBox='0 0 16 16'
                height='1em'
                width='1em'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z'></path>
                <path d='M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z'></path>
              </svg>
            )}
          </button>

          {location.pathname === '/' ? (
            <button
              onClick={handleToggleSpace}
              className={`Header__nav-button Header__nav-button--lights ${
                spaceOn ? ' Header__nav-button--lights-on' : ''
              }`}
            >
              🚀
            </button>
          ) : (
            <button
              onClick={handleToggleLights}
              className={`Header__nav-button Header__nav-button--lights ${
                lightsOn ? ' Header__nav-button--lights-on' : ''
              } `}
            >
              💡
            </button>
          )}
        </div>
        <button
          onClick={handleToggleMenu}
          className='Header__nav-button Header__nav-button--mobile-toggle'
        >
          <div
            className={`Header__nav-mobile-toggle ${menuIsOpen ? 'Header__nav-mobile-toggle--open' : ''}`}
          ></div>
        </button>

        <nav
          className={`Header__nav  ${menuIsOpen ? 'Header__nav--open' : ''}`}
        >
          <ul
            className='Header__nav-menu'
            onClick={handleToggleMenu}
          >
            <li className='Header__nav-item'>
              <Link to='/projects' className='Header__nav-link'>
                Projects
              </Link>
            </li>
            <li className='Header__nav-item'>
              <Link to='/about' className='Header__nav-link'>
                About Me
              </Link>
            </li>
            <li className='Header__nav-item'>
              <Link to='/contact' className='Header__nav-link'>
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
